import React from 'react';
import { utils } from '../../utils';
import BoardSprite from "./BoardSprite"
import { gameStateManager } from '../../App';
import { useEffect, useState } from "react";

const BoardTile = ( { textureCache, ...props } ) =>
{
  return (
    <BoardSprite
      textureCache={ textureCache }
      { ...props }
    />
  );
};

const PixiBoardTilesHandler = ( { textureCache, tileFolderName, boardTiles } ) =>
{
  const [ renderScale, setRenderScale ] = useState( 1.0 );

  useEffect( () =>
  {
    let onStageRenderDataChanged = ( stageRenderData ) =>
    {
      setRenderScale( stageRenderData.scale );
    };

    let currentStageRenderData = gameStateManager.addOnStageRenderDataChangeCallback( onStageRenderDataChanged );
    setRenderScale( currentStageRenderData.scale );

    return () =>
    {
      gameStateManager.removeOnStageRenderDataChangeCallback( onStageRenderDataChanged );
    };
  }, [] ); // Empty dependency array means "run once"




  // console.log( 'TILE HANDLER RENDERING' );

  // Compile the current state of the board tiles
  let boardTileSprites = [];
  let tileData;
  let tileCoord;

  for( let tileHash in boardTiles )
  {
    tileData = boardTiles[ tileHash ];
    tileCoord = utils.hashToCoord( tileHash );

    boardTileSprites.push(
      <BoardTile
        key={ "tile_" + tileHash }
        imageSrc={ `./tiles/${tileFolderName}/${tileData.sprite}.png` }
        renderScale={ renderScale }
        textureCache={ textureCache }
        x={ tileCoord.x }
        y={ -1 * tileCoord.y }
        angle={ tileData.rotation * 90 }
      />
    );

    // Add 'effects' overlay image
    boardTileSprites.push(
      <BoardTile
        key={ "tile_" + tileHash + "_effects" }
        imageSrc={ `./tiles/${tileFolderName}/base-tile-overlay.png` }
        renderScale={ renderScale }
        textureCache={ textureCache }
        x={ tileCoord.x + 0.033 }
        y={ -1 * tileCoord.y - 0.033 }
      />
    );
  }

  return (
    <>
      { boardTileSprites }
    </>
  );
}

export default React.memo( PixiBoardTilesHandler,
  ( prevProps, nextProps ) =>
  {
    // Comparison check
    // console.log( "COMP CHECK prevProps: ", prevProps, ", nextProps: ", nextProps );

    // Check for any change to the board tiles data
    let prevNumTiles = prevProps.boardTiles !== null ? Object.keys( prevProps.boardTiles ).length : 0;
    let nextNumTiles = nextProps.boardTiles !== null ? Object.keys( nextProps.boardTiles ).length : 0;

    // console.log( "prevNumTiles: ", prevNumTiles, "nextNumTiles", nextNumTiles );

    if( prevNumTiles !== nextNumTiles )
    {
      return false;
    }

    return true;
  }
);
